<template>
  <NuxtLayout>
    <div>
      <div>
        <ZeroResultsContainer
          headingMessage="Page Not Found"
          secondaryMessage="We're sorry, the page you requested could not be found. Please go back to the homepage"
          action="Go Back"
          @actionClicked="navigateTo({ path: '/' })"
        >
          <Svg404 />
        </ZeroResultsContainer>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup>
const props = defineProps({
  error: {
    type: Object,
    required: true,
  },
});
</script>
